// config/vendors.js
export const VENDOR_PRESETS = [
  {
    id: 'mckesson',
    name: 'McKesson',
    url: 'https://connect.mckesson.com',
    logo: '🏥',
    type: 'Distributor'
  },
  {
    id: 'cardinal',
    name: 'Cardinal Health',
    url: 'https://orderexpress.cardinalhealth.com',
    logo: '🏥',
    type: 'Distributor'
  },
  {
    id: 'medline',
    name: 'Medline',
    url: 'https://www.medline.com/ordering',
    logo: '🏥',
    type: 'Distributor'
  },
  {
    id: 'owens',
    name: 'Owens & Minor',
    url: 'https://www.owens-minor.com/myaccount',
    logo: '🏥',
    type: 'Distributor'
  },
  {
    id: 'henry',
    name: 'Henry Schein',
    url: 'https://www.henryschein.com',
    logo: '🏥',
    type: 'Distributor'
  },
  {
    id: 'concordance',
    name: 'Concordance Healthcare',
    url: 'https://portal.concordancehealthcare.com',
    logo: '🏥',
    type: 'Distributor'
  },
  {
    id: 'vizient',
    name: 'Vizient',
    url: 'https://www.vizientinc.com/member-portal',
    logo: '🤝',
    type: 'GPO'
  },
  {
    id: 'premier',
    name: 'Premier Inc',
    url: 'https://www.premierinc.com/member-portal',
    logo: '🤝',
    type: 'GPO'
  },
  {
    id: 'other',
    name: 'Other Vendor',
    url: '',
    logo: '🔧',
    type: 'Custom'
  }
];

export const MOCK_VENDOR_PRODUCTS = {
  mckesson: [
    { vendorSku: 'MCK-001234', name: 'Nitrile Exam Gloves (Box of 100)', category: 'PPE', vendorPrice: 19.80, unit: '100 gloves', url: 'https://connect.mckesson.com/product/001234' },
    { vendorSku: 'MCK-002345', name: 'N95 Respirator Masks (Box of 20)', category: 'PPE', vendorPrice: 34.50, unit: '20 masks', url: 'https://connect.mckesson.com/product/002345' },
    { vendorSku: 'MCK-003456', name: 'Lisinopril 10mg (Bottle of 90)', category: 'Pharma', vendorPrice: 38.00, unit: '90 tablets', url: 'https://connect.mckesson.com/product/003456' },
    { vendorSku: 'MCK-004567', name: 'Digital Thermometer (Unit)', category: 'Devices', vendorPrice: 10.25, unit: '1 unit', url: 'https://connect.mckesson.com/product/004567' },
    { vendorSku: 'MCK-005678', name: 'Gauze Pads 4x4 (Box of 100)', category: 'Med/Surg', vendorPrice: 15.25, unit: '100 pads', url: 'https://connect.mckesson.com/product/005678' },
    { vendorSku: 'MCK-006789', name: 'Surgical Suture Kit 4-0 Vicryl', category: 'Surgical', vendorPrice: 128.00, unit: '12 sutures', url: 'https://connect.mckesson.com/product/006789' }
  ],
  cardinal: [
    { vendorSku: 'CAH-111222', name: 'Metformin 500mg (Bottle of 180)', category: 'Pharma', vendorPrice: 32.00, unit: '180 tablets', url: 'https://orderexpress.cardinalhealth.com/product/111222' },
    { vendorSku: 'CAH-222333', name: 'Atorvastatin 20mg (Bottle of 90)', category: 'Pharma', vendorPrice: 65.00, unit: '90 tablets', url: 'https://orderexpress.cardinalhealth.com/product/222333' },
    { vendorSku: 'CAH-333444', name: 'Blood Pressure Monitor', category: 'Devices', vendorPrice: 73.00, unit: '1 unit', url: 'https://orderexpress.cardinalhealth.com/product/333444' },
    { vendorSku: 'CAH-444555', name: 'IV Catheter 20G (Box of 50)', category: 'Med/Surg', vendorPrice: 55.00, unit: '50 catheters', url: 'https://orderexpress.cardinalhealth.com/product/444555' },
    { vendorSku: 'CAH-555666', name: 'Face Shields (Box of 25)', category: 'PPE', vendorPrice: 31.00, unit: '25 shields', url: 'https://orderexpress.cardinalhealth.com/product/555666' },
    { vendorSku: 'CAH-666777', name: 'Alcohol Prep Pads (Box of 200)', category: 'Med/Surg', vendorPrice: 11.50, unit: '200 pads', url: 'https://orderexpress.cardinalhealth.com/product/666777' }
  ]
};